import React, { useState } from 'react'
import '../../styles/admin.css'

const DeleteConfirmation = ({ 
  questionText, 
  showDeleteConfirmation, 
  setShowDeleteConfirmation, 
  onConfirm,
  confirmationWord = 'DELETE'
}) => {
  const [confirmWord, setConfirmWord] = useState('')

  function closeBox() {
    setConfirmWord('')
    setShowDeleteConfirmation(false)
  }

  if (showDeleteConfirmation) {
    return (
      <div className="delete-confirmation-container">
        <div style={{
            marginBottom: '20px',
            fontWeight: '600',
            fontSize: '1.1rem',
            color: confirmationWord === 'DELETE' ? '#c53030' : '#2d3748',
            textAlign: 'center',
            lineHeight: '1.5'
          }}
        >
          {questionText}
        </div>
        
        <div className="admin-input-group">
          <label htmlFor="confirmWord" className="admin-label">
            Type "{confirmationWord}" to confirm
          </label>
          <input
            name="confirmWord"
            id="confirmWord"
            className="admin-input"
            value={confirmWord}
            onChange={(e) => setConfirmWord(e.target.value)}
            placeholder={confirmationWord}
            autoComplete="off"
          />
        </div>

        <div className="admin-button-group" style={{ borderTop: 'none', marginTop: '10px' }}>
          <button 
            type="button" 
            className="btn btn-secondary" 
            onClick={closeBox}
            style={{ flex: 1 }}
          >
            Cancel
          </button>
          <button 
            type="button" 
            className={confirmationWord === 'DELETE' ? "btn btn-danger" : "btn btn-primary"}
            disabled={confirmWord !== confirmationWord} 
            onClick={onConfirm}
            style={{ flex: 1 }}
          >
            Confirm
          </button>
        </div>
      </div>
    )
  } else {
    return <></>
  }
}

export default DeleteConfirmation
